import $ from 'jquery';
import AsyncMenuData from './lib/data/async-menu';
import MessagesMenu from './lib/ui/messages-menu';
import DetachedDropdown from '@99designs/asimov/detached-dropdown';
import { trackLink, trackEvent } from '@99designs/utils/platform';

import '@99designs/asimov/core';
import '@99designs/asimov/off-canvas';
import '@99designs/asimov/promo-bar';
import '@99designs/asimov/tooltip';

export default function() {
    var role = $('[data-globalnavui-userrole]').data('globalnavui-userrole') || 'logged-out';
    var dropdowns = [];

    AsyncMenuData.attachTo(document, {
        needsInitialData: ['contest-holder', 'designer'].some(function(item) {
            return item === role;
        }),
    });

    MessagesMenu.attachTo('[data-globalnavui]', {
        key: 'messages',
        content: '[data-globalnavui-messages]',
        detachedDropdown: '[data-globalnavui-messages-detached-dropdown]',
        offCanvasMenuItem: '[data-globalnavui-messages-off-canvas-menu-item]',
        countContainer: '[data-globalnavui-messages-count-container]',
        link: '[data-globalnavui-messages-link]',
        count: '[data-globalnavui-messagecount]',
    });

    $('[data-oc-name]').offCanvas();

    $('[data-global-nav-detached-dropdown]').each(
        function(i, el) {
            dropdowns.push(new DetachedDropdown($(el)));
        }.bind(this)
    );

    $('[data-promo-bar]').promoBar({
        onShow: elem => {
            trackEvent('Viewed Notice Bar', {
                notice_bar_name: elem.name,
            });
            trackLink(
                elem.$el
                    .find('a')
                    .not('[data-promo-bar-dismiss]')
                    .get(),
                'Clicked Notice Bar Link',
                {
                    notice_bar_name: elem.name,
                }
            );
        },
    });

    $('[data-global-nav-tooltip]').tooltip();

    // Use link elements for interaction instead of clickable spans

    $('[data-no-link]').on('click', function(e) {
        // Middle click, cmd click, and ctrl click should open
        // links in a new tab as normal.
        if (e.which > 1 || e.metaKey) {
            return true;
        } else {
            e.preventDefault();
        }
    });
}



// WEBPACK FOOTER //
// ./~/@99designs/brand-container/index.js